module.exports = __webpack_public_path__ + "static/uliege_logo_gris-85211b74c3e27a52addfc3d301c22e7e.png";